module.exports = __webpack_public_path__ + "img/cpzxIcon3.d9258686.png";